module.exports = __webpack_public_path__ + "static/media/mymotors.2def36d3.png";